module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "eagle.4a919ab7.jpg";